// JsFromRoutes CacheKey ed2b6211bd16b89b2a4f61ce64860474
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/:account_id/shortcuts'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/shortcuts'),
  new: /* #__PURE__ */ definePathHelper('get', '/:account_id/shortcuts/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/:account_id/shortcuts/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/:account_id/shortcuts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/shortcuts/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/shortcuts/:id'),
}
